import { Navbar } from '@codeparva/ui-components-library';
import React from 'react';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { NavBarTypes } from './navBarTypes';
import { useThemeContext } from './hooks/themeContext';

export const NavBarIcons = ({
  AddressIcon,
  facilityAddress,
  googleMapsUrl,
  PhoneNumberIcon,
  phoneNumber,
  phoneNumberRedirect,
  locationType,
}: NavBarTypes.TNavBarIcons) => {
  const selectedTheme = useThemeContext();
  const textColor = selectedTheme === 'dark' ? 'primary' : 'white';
  return (
    <>
      {locationType === 'single' ? (
        <>
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="nofollow"
            className="navBarIconAddressData"
          >
            <FontAwesomeIcon
              iconClassName={AddressIcon}
              iconContextProps={{
                className: `navBarAddressIcon has-text-primary`,
              }}
            />
            <span className="navBarIconAddress">{facilityAddress}</span>
          </a>
          <Navbar.Item
            href={phoneNumberRedirect}
            className={`navBarPhoneData has-text-${textColor} has-text-weight-bold`}
          >
            {' '}
            <FontAwesomeIcon
              iconClassName={PhoneNumberIcon}
              iconContextProps={{
                className: `navBarPhoneNumberIcon has-text-primary`,
              }}
            />
            <span className="navBarIconPhoneNumber">{phoneNumber}</span>
          </Navbar.Item>{' '}
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default NavBarIcons;
